import type { MRT_RowData, MRT_TableInstance } from "mantine-react-table-open";

export function getColSum<T extends MRT_RowData>(
  table: MRT_TableInstance<T>,
  columnId: string
): number | null {
  const colValues = table
    .getPrePaginationRowModel()
    .rows.map((row) => row.original[columnId]);

  if (colValues.every((value) => value === null || value === undefined)) {
    return null;
  }
  return colValues.reduce((sum, value) => sum + (value ?? 0), 0);
}
